var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Property, Complex, ChildProperty } from '@syncfusion/ej2-base';
import { TextStyle, Margin } from '../core/appearance';
import { Point } from '../primitives/point';
import { AnnotationConstraints } from '../enum/enum';
import { randomId } from '../utility/base-util';
import { DiagramTooltip } from './tooltip';
/**
 * Defines the hyperlink for the annotations in the nodes/connectors
 */
export class Hyperlink extends ChildProperty {
}
__decorate([
    Property('blue')
], Hyperlink.prototype, "color", void 0);
__decorate([
    Property('')
], Hyperlink.prototype, "content", void 0);
__decorate([
    Property('')
], Hyperlink.prototype, "link", void 0);
__decorate([
    Property('None')
], Hyperlink.prototype, "textDecoration", void 0);
__decorate([
    Property('NewTab')
], Hyperlink.prototype, "hyperlinkOpenState", void 0);
/**
 * Defines the textual description of nodes/connectors
 */
export class Annotation extends ChildProperty {
    // tslint:disable-next-line:no-any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(parent, propName, defaultValue, isArray) {
        super(parent, propName, defaultValue, isArray);
        if (!defaultValue.id) {
            if (parent.parentObj && parent.parentObj.propName && parent.parentObj.propName === 'phases') {
                this.id = parent.parentObj.id;
            }
            else {
                this.id = randomId();
            }
        }
    }
}
__decorate([
    Property('')
], Annotation.prototype, "content", void 0);
__decorate([
    Property(undefined)
], Annotation.prototype, "template", void 0);
__decorate([
    Property('String')
], Annotation.prototype, "annotationType", void 0);
__decorate([
    Property(true)
], Annotation.prototype, "visibility", void 0);
__decorate([
    Property(AnnotationConstraints.InheritReadOnly)
], Annotation.prototype, "constraints", void 0);
__decorate([
    Complex(undefined, Hyperlink)
], Annotation.prototype, "hyperlink", void 0);
__decorate([
    Property('')
], Annotation.prototype, "id", void 0);
__decorate([
    Property()
], Annotation.prototype, "width", void 0);
__decorate([
    Property()
], Annotation.prototype, "height", void 0);
__decorate([
    Property(0)
], Annotation.prototype, "rotateAngle", void 0);
__decorate([
    Property('Parent')
], Annotation.prototype, "rotationReference", void 0);
__decorate([
    Complex({ strokeWidth: 0, strokeColor: 'transparent', fill: 'transparent' }, TextStyle)
], Annotation.prototype, "style", void 0);
__decorate([
    Property('Center')
], Annotation.prototype, "horizontalAlignment", void 0);
__decorate([
    Property('Center')
], Annotation.prototype, "verticalAlignment", void 0);
__decorate([
    Complex({}, Margin)
], Annotation.prototype, "margin", void 0);
__decorate([
    Complex({ top: undefined, bottom: undefined, left: undefined, right: undefined }, Margin)
], Annotation.prototype, "dragLimit", void 0);
__decorate([
    Property('Shape')
], Annotation.prototype, "type", void 0);
__decorate([
    Complex({}, DiagramTooltip)
], Annotation.prototype, "tooltip", void 0);
__decorate([
    Property()
], Annotation.prototype, "addInfo", void 0);
/**
 * Defines the textual description of nodes/connectors with respect to bounds
 */
export class ShapeAnnotation extends Annotation {
    /* eslint-disable */
    constructor(parent, propName, defaultValue, isArray) {
        super(parent, propName, defaultValue, isArray);
    }
    // eslint-disable-next-line valid-jsdoc
    /**
     * @private
     * Returns the module of class ShapeAnnotation
     */
    getClassName() {
        return 'ShapeAnnotation';
    }
}
__decorate([
    Complex({ x: 0.5, y: 0.5 }, Point)
], ShapeAnnotation.prototype, "offset", void 0);
/**
 * Defines the connector annotation
 */
export class PathAnnotation extends Annotation {
    /* eslint-disable */
    constructor(parent, propName, defaultValue, isArray) {
        super(parent, propName, defaultValue, isArray);
    }
    /* eslint-enable */
    /**
     * Returns the module of class PathAnnotation.
     *
     * @returns {string}  Returns the module of class PathAnnotation.
     * @private
     */
    getClassName() {
        return 'PathAnnotation';
    }
}
__decorate([
    Property(0.5)
], PathAnnotation.prototype, "offset", void 0);
__decorate([
    Complex({ x: 0, y: 0 }, Point)
], PathAnnotation.prototype, "displacement", void 0);
__decorate([
    Property('Center')
], PathAnnotation.prototype, "alignment", void 0);
__decorate([
    Property(false)
], PathAnnotation.prototype, "segmentAngle", void 0);
